import authInterceptor from "../AuthInterceptor";

export const RankingAPI = {
  // getRannkList: () =>
  //     authInterceptor.get(`ranking-api/rank-list-api/`)
  //         .then((response) => response.data)
  //         .catch((error) => error.response),
  getRannkList: (config = {}) =>
    authInterceptor
      .get(`ranking-api/rank-list-api/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  resetRank: (config = {}) =>
    authInterceptor
      .get(`ranking-api/update-data-from-csv/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  projectedCostSaving: (bodyData) =>
    authInterceptor
      .post(`ranking-api/projected-cost-saving/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  rankListFilter: (bodyData) =>
    authInterceptor
      .post(`ranking-api/rank-list-api/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  getStatusOptions: () =>
    authInterceptor
      .get(`ranking-api/statuses/`)
      .then((response) => response.data)
      .catch((error) => error.response),
  getFilterFieldOptions: (config = {}) =>
    authInterceptor
      .get(`ranking-api/rank-list-filter-options/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  exportRankList: (config = {}) =>
    authInterceptor
      .get(`ranking-api/rank-list-api/`, { ...config, responseType: "blob" })
      .then((response) => response)
      .catch((error) => Promise.reject(error)),
  getColumnConfig: () =>
    authInterceptor
      .get(`ranking-api/column-config/`)
      .then((response) => response.data)
      .catch((error) => error.response),
  updateColumnConfig: (bodyData) =>
    authInterceptor
      .post(`ranking-api/column-config/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
};
